import { ISnPlayer } from '../interfaces';

export class SnPlayerGroupReference {
  public players: Set<ISnPlayer> = new Set();

  constructor(private readonly _players: Set<ISnPlayer>) {
    this.players = this._players;
  }

  public play(): void {
    this._players.forEach((player) => player.play());
  }

  public pause(): void {
    this._players.forEach((player) => player.pause());
  }

  public forward(amount: number): void {
    this._players.forEach((player) => player.forward(amount));
  }

  public back(amount: number): void {
    this._players.forEach((player) => player.back(amount));
  }

  public fastForward(): void {
    this._players.forEach((player) => player.fastForward());
  }

  public rewind(): void {
    this._players.forEach((player) => player.rewind());
  }

  public destroy(bypassGroup?: boolean): void {
    this._players.forEach((player) => player.destroyStream(bypassGroup));
  }

  public initialize(): void {
    this._players.forEach((player) => player.initialization());
  }
}
